const LineArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17.8186 13.0508L12.0015 18.8679L6.18444 13.0508"
        stroke="#FF5E00"
        stroke-width="1.91667"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 4.97266L12 17.7504"
        stroke="#FF5E00"
        stroke-width="1.91667"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default LineArrow;
